var DisableBodyScroll = {
  methods: {
    opened() {
      var body = document.getElementsByTagName('body')[0]
      body.style.overflow = 'hidden'
    },
    closed() {
      var body = document.getElementsByTagName('body')[0]
      body.style.overflow = 'scroll'
    }
  }
}

export default DisableBodyScroll;
